import React from "react";
const MailChimpPopup = () => {
  return <script id="mcjs" dangerouslySetInnerHTML={{
    __html: `!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/bec85cbdc3a23269a826db329/2e5a1f8c73514091de11a52cc.js");`
  }} data-sentry-component="MailChimpPopup" data-sentry-source-file="mail-chimp-popup.jsx"></script>;
};
export default MailChimpPopup;